import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CurrencyMaskConfig } from 'ng2-currency-mask';
import { MudarFocoService } from 'src/app/core/services/behavior/mudar-foco.service';
import { HelpersUtil } from 'src/app/shared/utils/helpers.util';

@Component({
  selector: 'app-area-troco',
  templateUrl: './area-troco.component.html',
  styleUrls: ['./area-troco.component.css']
})
export class AreaTrocoComponent implements OnInit {
  public readonly optionsMask: CurrencyMaskConfig = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    align: 'center',
    allowNegative: false,
    precision: 2,
    suffix: ''
  };

  public trocoDigitado = 0;

  @ViewChild("inputTroco") public inputTroco: ElementRef<HTMLInputElement>;

  constructor(
    private _mudarFocoService: MudarFocoService
  ) { }

  public mudarFocoParaInputObservacaoOnKeydownEnter() {
    this._mudarFocoService.mudarFoco$.next(true);
  }

  public ngOnInit() {
    HelpersUtil.executeAfterDelay(() => this.inputTroco.nativeElement.focus());
  }
}
